"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Arrow = exports.Container = exports.Content = exports.Title = exports.StyledWrapper = exports.ANIMATION_DURATION = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const arrow_1 = require("./arrow");
exports.ANIMATION_DURATION = 200;
exports.StyledWrapper = styled_components_1.default.div `
  /* css-transition-group */
  opacity: 0;
  &.enter-active,
  &.enter-done {
    opacity: 1;
  }
  transition-property: opacity;
  transition-duration: ${exports.ANIMATION_DURATION}ms;
  transition-timing-function: ease;
`;
exports.Title = styled_components_1.default.div ``;
exports.Content = styled_components_1.default.div ``;
const color = (0, styled_components_1.css) `
  ${({ variant, theme: { colors } }) => (variant === 'secondary' ? colors.text.body : colors.white.s100)};
`;
const backgroundColor = (0, styled_components_1.css) `
  ${({ variant, theme }) => {
    switch (variant) {
        case 'secondary':
            return theme.colors.white.s100;
        case 'success':
            return theme.colors.green.s75;
        default:
            return theme.colors.status.info;
    }
}}
`;
const boxShadow = (0, styled_components_1.css) `
  ${({ theme, variant }) => variant === 'secondary' &&
    (0, styled_components_1.css) `
      box-shadow: ${theme.shadow.s300};
    `};
`;
exports.Container = styled_components_1.default.div `
  /* display */
  border-radius: 2px;
  padding: ${({ theme: { space } }) => `${space.s050} ${space.s100}`};

  /* text */
  ${({ theme }) => (0, styled_components_1.css)(theme.typography.body.tinyText)};
  text-align: center;
  white-space: pre;

  /* color */
  background-color: ${backgroundColor};
  color: ${color};
  ${boxShadow};
`;
exports.Arrow = styled_components_1.default.div `
  /* color */
  border-color: ${({ customColor }) => (customColor ? customColor : backgroundColor)};

  height: 0;
  width: 0;

  ${({ placement }) => (0, arrow_1.getArrowCssHelper)(placement)};
`;
